<template>
  <div class="VolleyballInfo">
    <MatchCompany />
    <MatchProject/>
  </div>
</template>

<script>
import MatchCompany from '@comm/components/MatchCompany.vue'
import MatchProject from '@comm/components/MatchProject.vue'
export default {
  name: 'VolleyballInfo',
  props: {
    
  },
  data() {
    return {

    }
  },
  components: {
    MatchCompany,
    MatchProject
  },
  mounted() {},
  methods: {
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/comm/components/match/volleyball/components/VolleyballInfo.vue